import { ResetFilterButton } from '../../../components/ui/button';
import { TextSearchFilter } from '../../../components/ui/search-filter';
import { useUrlFilter } from '../../../hooks';

export const UserListFilters = () => {
    const { searchText, setSearchText } = useUrlFilter();

    return (
        <div className="flex flex-wrap items-center gap-2">
            <TextSearchFilter
                placeholder="users"
                value={searchText}
                onChangeSearch={(e) => setSearchText(e.target.value)}
            />
            <ResetFilterButton />
        </div>
    );
};

UserListFilters.displayName = 'UserListFilters';
